<div class="row">
    <div class="col-3">
        <div class="col-left p-3 pt-5 p-xl-4 pt-xl-5">
            <h2>{{ 'popins.print.title' | translate }}</h2>
            <p class="info">{{ 'popins.print.info' | translate }}</p>
            <h3>{{ 'popins.print.selected' | translate }}</h3>
            <div class="row selected-medias">
                <div class="col-9">{{ 'popins.print.plans' | translate }}</div>
                <div class="col-3 text-right">{{totalSelectedPlan2DCount}}</div>
            </div>
            <div class="row selected-medias">
                <div class="col-9">{{ 'popins.print.views_3d' | translate }}</div>
                <div class="col-3 text-right">{{totalSelectedSnapshotCount}}</div>
            </div>
            <div class="row selected-medias">
                <div class="col-9">{{ 'popins.print.realistic_views' | translate }}</div>
                <div class="col-3 text-right">{{totalSelectedRenderHQCount}}</div>
            </div>
        </div>
    </div>

    <div class="col-9">
        <div class="header-actions">
            <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>

        <div class="modal-content-body">

            <div class="pr-5 py-5 medias-list">

                <div class="row">
                        <figure class="col-3" *ngFor="let media of medias">
                                <div class="card" [class.selected]="media.selected" [class.not-ready]="!media.selectable" (click)="select(media)">
                                    <div class="embed-responsive embed-responsive-1by1">
                                        <div class="embed-responsive-item" [style.background-image]="('url(\''+media.url+'\')') | safeStyle">
                                        </div>
                                    </div>
                                </div>
                                
                            </figure>

                </div>

            
                
            </div>

        </div>


        

        <div class="footer">
            <div class="row">
                    <div class="col-6">
                            <ng-hbm-bdi-btn class="light-grey" (click)="selectAll()" [label]="'popins.print.select_all' | translate"></ng-hbm-bdi-btn>
                        </div>
                        <div class="col-6 text-right">
                                <ng-hbm-bdi-btn class="primary" (click)="print()" [loading]="printLoading" [disabled]="totalSelectedMediaCount == 0" [label]="('popins.print.cta' | translate)+((totalSelectedMediaCount > 0) ? (' ('+totalSelectedMediaCount+')') : '')"></ng-hbm-bdi-btn>
                            </div>
            </div>
            
        </div>
    </div>
</div>